import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * - Remet la page tout en haut à chaque changement de route.
 * - Envoie un événement page_view à Google Analytics 4 (gtag) à chaque navigation SPA.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // Track SPA route changes in GA4
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, search]);
  return null;
}
